module.exports = __webpack_public_path__ + "static/media/checked-1.da188ccb.png";